export default __webpack_public_path__ + "static/services-mockup-7-dcaf43806bf15995f1a6be1da4fe4975.png";